export const GET_SITE_ITEMS_BY_SITE_IDS_LOADING =
  'GET_SITE_ITEMS_BY_SITE_IDS_LOADING';
export const GET_SITE_ITEMS_BY_SITE_IDS = 'GET_SITE_ITEMS_BY_SITE_IDS';
export const GET_SITE_ITEMS_BY_SITE_IDS_LOADING_ERROR =
  'GET_SITE_ITEMS_BY_SITE_IDS_LOADING_ERROR';
export const SET_SELECTED_SITES = 'SET_SELECTED_SITES';
export const SAVE_TRUCK_ROUTE_LOADING = 'SAVE_TRUCK_ROUTE_LOADING';
export const SAVE_TRUCK_ROUTE = 'SAVE_TRUCK_ROUTE';
export const SAVE_TRUCK_ROUTE_LOADING_ERROR = 'SAVE_TRUCK_ROUTE_LOADING_ERROR';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const CLEAR_SAVE_TRUCK_ROUTE = 'CLEAR_SAVE_TRUCK_ROUTE';
export const CLEAR_SITE_ITEMS = 'CLEAR_SITE_ITEMS';
export const SELECTED_TRUCK_ROUTE_DETAIL_LOADING =
  'SET_TRUCK_ROUTE_DETAIL_LOADING';
export const SELECTED_TRUCK_ROUTE_DETAIL = 'SET_TRUCK_ROUTE_DETAIL';
export const SELECTED_TRUCK_ROUTE_DETAIL_LOADING_ERROR =
  'SET_TRUCK_ROUTE_DETAIL_LOADING_ERROR';
export const CLEAR_SITE_ITEMS_MESSAGE = 'CLEAR_SITE_ITEMS_MESSAGE';
export const SET_SITE_ITEMS_MESSAGE = 'SET_SITE_ITEMS_MESSAGE';
export const GET_ITEMS_BY_VENDOR_IDS = 'GET_ITEMS_BY_VENDOR_IDS';
export const GET_ITEMS_BY_VENDOR_IDS_LOADING =
  'GET_ITEMS_BY_VENDOR_IDS_LOADING';
export const GET_ITEMS_BY_VENDOR_IDS_LOADING_ERRORS =
  'GET_ITEMS_BY_VENDOR_IDS_LOADING_ERRORS';
export const GET_TRUCK_ROUTE_ASSIGNMENT_TYPES_LOADING =
  'GET_TRUCK_ROUTE_ASSIGNMENT_TYPES_LOADING';
export const GET_TRUCK_ROUTE_ASSIGNMENT_TYPES_LOADING_ERROR =
  'GET_TRUCK_ROUTE_ASSIGNMENT_TYPES_LOADING_ERROR';
export const GET_TRUCK_ROUTE_ASSIGNMENT_TYPES =
  'GET_TRUCK_ROUTE_ASSIGNMENT_TYPES';
export const GET_TRUCK_ROUTE_TYPES_LOADING = 'GET_TRUCK_ROUTE_TYPES_LOADING';
export const GET_TRUCK_ROUTE_TYPES = 'GET_TRUCK_ROUTE_TYPES';
export const GET_TRUCK_ROUTE_TYPES_LOADING_ERROR =
  'GET_TRUCK_ROUTE_TYPES_LOADING_ERROR';



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/state/createedittruckroute/types.js